<template>
  <v-container fluid class="mt-0 pa-0">
    <!-- Desktop row -->
    <v-row class="d-none d-md-flex" align="center" no-gutters>
      <v-col cols="12" md="5" offset-md="1">
        <h1 v-if="omOnlyExecutor" class="desktop-home-header">
          The quickest way <br />to draft your will
        </h1>
        <h1 v-else class="desktop-home-header">
          The quickest way <br />to draft your will &amp; <br />choose your
          Executor
        </h1>

        <v-btn
          left
          class="mt-12"
          :color="whitelabel.getStartedBtnColor"
          to="/signup"
          rounded
          depressed
          x-large
        >
          <span>GET STARTED</span
          ><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
        <Trustpilot v-if="whitelabel.showTrustpilot" />
      </v-col>
      <v-col md="6">
        <v-img
          :src="require(`@/assets/${whitelabel.images.homeMain}`)"
          alt="Online will creation"
          title="Online will creation"
        />
      </v-col>
    </v-row>

    <!-- Mobile row -->
    <v-row no-gutters class="d-flex d-md-none">
      <v-col cols="12" class="mt-6 pt-2">
        <h2 v-if="omOnlyExecutor" class="mobile-home-header">
          The quickest way to draft your will
        </h2>
        <h2 v-else class="mobile-home-header">
          The quickest way to draft your will &amp; choose your Executor
        </h2>
        <v-btn
          left
          class="mt-6"
          :color="whitelabel.getStartedBtnColor"
          to="/signup"
          rounded
          depressed
          large
        >
          <span>GET STARTED</span
          ><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
        <Trustpilot v-if="whitelabel.showTrustpilot" />
      </v-col>
      <v-col cols="12">
        <v-img
          :src="require(`@/assets/${whitelabel.images.mobileHomeMain}`)"
          aspect-ratio="1"
          alt="Online will creator"
          title="Online will creator"
          class="mx-12"
        />
      </v-col>
    </v-row>

    <HomeSteps />
    <Usps />
    <EstateAdministrationCostCalculatorIntro />

    <Testimonials v-if="whitelabel.showHomePageTestimonials" />
    <HomePagePopup v-model="showPopup" />
  </v-container>
</template>

<script>
import HomeSteps from "./HomeSteps.vue";
import Usps from "./Usps.vue";
import Testimonials from "./Testimonials.vue";
import Trustpilot from "./Trustpilot.vue";
import HomePagePopup from "./HomePagePopup";
import { HOME_QUERY } from "../../constants/graphql/home";
import EstateAdministrationCostCalculatorIntro from "../guest/EstateCostCalculator/EstateAdministrationCostCalculatorIntro.vue";

export default {
  name: "HomePage",
  metaInfo() {
    return {
      link: [
        {
          rel: "canonical",
          href: this.whitelabel.canonicalUrls.homepage,
        },
      ],
    };
  },
  components: {
    HomeSteps,
    Usps,
    Testimonials,
    Trustpilot,
    HomePagePopup,
    EstateAdministrationCostCalculatorIntro,
  },
  data() {
    return {
      showPopup: false,
      home: {},
    };
  },
  computed: {
    omOnlyExecutor() {
      return this.home?.omOnlyExecutor === true;
    },
    hasCompetitionMessage() {
      return this.home?.competition?.competitionActive;
    },
    messageText() {
      if (this.home?.competition?.homepageText) {
        return this.home?.competition?.homepageText;
      }
    },
  },
  created() {
    if (this.whitelabel.homePagePopupMessage) {
      this.showPopup = true;
    }
  },
  apollo: {
    home: {
      query: HOME_QUERY,
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>

<style lang="scss" scoped>
.desktop-home-header {
  font-size: 43px;
}

.mobile-home-header {
  font-size: 36px;
  padding-right: 15px;
  padding-left: 15px;
}

h2 {
  font-size: 40px;
}

.home-steps {
  height: 250px;
}
</style>
